import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import * as StringFormatter from '../../../global/formatters/string-formatter.js'
import Table from '../../../components/Table/Table.jsx'
import { camelCase } from 'lodash'
import { getLinkUrl } from '../../utility/index.js'
import { Link2 } from '../link/link.jsx'

export const MutualFundsTable = ({ parameters }) => {
  const [tableData, setTableData] = useState([])
  const [tableType, setTableType] = useState('TARGET')

  const fetchTableData = async () => {
    const ApiType = parameters?.scope
    try {
      const { data } = await Axios.get(
        `/service/funds/literature?classes=Institutional3&type=${ApiType}`
      )
      const response = data?.fundLiterature?.literature?.funds?.fund || []
      const result = response?.reduce(
        (p, i) => [
          ...p,
          {
            key: i?.cusip,
            cusip: i?.cusip,
            fundName: i?.fundName,
            group: i?.subCategoryName,
            docs: i?.documentTypes?.documentType?.reduce(
              (j, n) => ({
                ...j,
                ...n?.documents?.document?.reduce(
                  (y, k) => ({
                    ...y,
                    [camelCase(k?.fileName)]: {
                      fileName: k?.fileName,
                      url: k?.url,
                    },
                  }),
                  {}
                ),
              }),
              {}
            ),
          },
        ],
        []
      )
      result.sort((a, b) => a.group.localeCompare(b.group))
      setTableData(result)
      setTableType(ApiType)
    } catch (err) {
      console.log('MutualFundsTable', err)
    }
  }

  const getColumns = () => {
    const tableHeads = {
      DCIO: [
        {
          name: 'group',
          className: 'Table-header',
          ariaLabel: 'Groups',
          content: <div>&nbsp;</div>,
          cell: {
            content: () => <div></div>,
          },
        },
        {},
        {
          name: 'factSheets',
          ariaLabel: 'Fact Sheets',
          content: <div>Fact Sheets</div>,
        },
        {
          name: 'commentaries',
          ariaLabel: 'Commentaries',
          content: <div>Commentaries</div>,
        },
        {
          name: 'fundGuides',
          ariaLabel: 'Fund Guides',
          content: <div>Fund Guides</div>,
        },
      ],
      TARGET: [
        {},
        {
          name: 'factSheets',
          ariaLabel: 'Fact Sheets',
          content: <div>Fact Sheets</div>,
        },
      ],
    }
    const columns = [
      {
        name: 'fundName',
        ariaLabel: 'Fund Name',
        content: <div>Fund Name</div>,
        className: 'Table-header',
        cell: {
          content: (fund) => (
            <a
              className="u-textBold"
              href={`/investment-products/mutual-funds/${StringFormatter.urlSafe(
                fund.fundName
              )}/Class-I/details/?cusip=${fund.cusip}`}
            >
              {fund.fundName}
            </a>
          ),
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) =>
            !fund?.docs?.factSheet?.fileName ? (
              <></>
            ) : (
              <Link2
                url={getLinkUrl(fund?.docs?.factSheet)}
                text={`${tableType === 'DCIO' ? '' : 'QDIA'} ${
                  fund?.docs?.factSheet?.fileName
                } (PDF)`}
                textClasses="u-textSecondary u-textSizeMsr"
              />
            ),
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) =>
            !fund?.docs?.quarterlyFundCommentary?.fileName ? (
              <></>
            ) : (
              <Link2
                url={getLinkUrl(fund?.docs?.quarterlyFundCommentary)}
                text={`${fund?.docs?.quarterlyFundCommentary?.fileName} (PDF)`}
                textClasses="u-textSecondary u-textSizeMsr"
              />
            ),
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) => {
            let data = null
            if (fund?.docs?.investorGuide?.fileName) {
              data = fund?.docs?.investorGuide
            }
            if (fund?.docs?.productGuide?.fileName) {
              data = fund?.docs?.productGuide
            }
            return !data ? (
              <></>
            ) : (
              <Link2
                url={getLinkUrl(data)}
                text={`${data?.fileName} (PDF)`}
                textClasses="u-textSecondary u-textSizeMsr"
              />
            )
          },
        },
      },
    ]

    return tableHeads[tableType]?.map((i, idx) =>
      tableType === 'DCIO' && idx === 0
        ? { ...i }
        : {
            ...columns[tableType === 'DCIO' ? idx - 1 : idx],
            ...i,
          }
    )
  }

  useEffect(() => {
    fetchTableData()
  }, [])

  return (
    <div className="investment-products">
      <Table
        isGrouped={tableType === 'DCIO'}
        columns={getColumns()}
        rows={tableData}
        emptyMessage={<strong>No matching results found...</strong>}
      />
    </div>
  )
}
